module.exports = __webpack_public_path__ + "img/36902-051.af8abbd1.jpg";